import { motion } from 'motion/react'
import { ScreenShell } from '@/components/layout/ScreenShell'
import { GameButton } from '@/components/ui/GameButton'
import { PixelIcon } from '@/components/ui/PixelIcon'
import { useGraceLeaderboard } from '@/hooks/useGraceLeaderboard'
import { useAuth } from '@/arcade'

export function LeaderboardScreen() {
  const { entries, loading, refresh, graceScore } = useGraceLeaderboard(50)
  const { user, isSignedIn } = useAuth()

  return (
    <ScreenShell
      title="Grace"
      actions={
        <GameButton size="sm" variant="ghost" icon="retry" onClick={refresh}>
          Refresh
        </GameButton>
      }
    >
      <div className="mb-4 rounded-[var(--r-lg)] bg-[var(--surface)] shadow-emboss border border-[var(--edge)]/40 p-4 flex items-center gap-3">
        <div className="grid place-items-center w-12 h-12 rounded-full bg-[var(--surface-raised)]" style={{ color: 'var(--coin)' }}>
          <PixelIcon name="trophy" size={24} />
        </div>
        <div>
          <div className="text-xs text-[var(--text-dim)]">Your Grace Score</div>
          <div className="font-display text-2xl font-black tabular-nums">{graceScore}</div>
        </div>
        {!isSignedIn && <span className="ml-auto text-xs text-[var(--text-faint)] text-right max-w-[40%]">Sign in on Profile to rank.</span>}
      </div>

      {loading ? (
        <div className="grid place-items-center py-12 text-[var(--text-faint)]">
          <PixelIcon name="loading" size={28} className="animate-spin" />
        </div>
      ) : entries.length === 0 ? (
        <div className="grid place-items-center py-12 text-[var(--text-faint)] text-center gap-2">
          <PixelIcon name="chart" size={28} />
          <p>No scores yet. Be the first home.</p>
        </div>
      ) : (
        <div className="flex flex-col gap-1.5">
          {entries.map((e) => {
            const isMe = user?.username === e.username
            return (
              <motion.div
                key={`${e.rank}-${e.username}`}
                initial={{ opacity: 0, x: -8 }}
                animate={{ opacity: 1, x: 0 }}
                className={[
                  'flex items-center gap-3 rounded-[var(--r-md)] px-4 py-2.5 border',
                  isMe ? 'bg-[var(--surface-raised)] border-[var(--ember)]/50' : 'bg-[var(--surface)] border-[var(--edge)]/30',
                ].join(' ')}
              >
                <span className="font-display font-black w-8 tabular-nums" style={{ color: e.rank <= 3 ? 'var(--coin)' : 'var(--text-faint)' }}>
                  {e.rank}
                </span>
                <span className="flex-1 min-w-0 truncate font-semibold">{e.username}</span>
                <span className="font-display font-bold tabular-nums">{e.score}</span>
              </motion.div>
            )
          })}
        </div>
      )}
    </ScreenShell>
  )
}
